import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';

const LastActiveBadge = ({ lastActive ,isOnline}) => {
  const profileLastActive = lastActive && moment(lastActive).fromNow();
  return profileLastActive < 5 ? (
    <span className={`online-status online`}></span>
  ) : (
    <OverlayTrigger
      placement="right"
      overlay={
        !!lastActive ? <Tooltip id={`tooltip-top`}>{profileLastActive}</Tooltip> : <span></span>
      }
    >
      
      <span className={isOnline ? "online-status online" : "online-status offline"}></span>
    </OverlayTrigger>
  );
};

export default LastActiveBadge;
